import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import EditIcon from "../../../../components/Icons/EditIcon";
import DeleteIcon from "../../../../components/Icons/DeleteIcon";
import MainHeading from "../../../../components/comman/MainHeading";
import FilterComponent from "../../../../components/comman/FilterComponent";
import CommonTable from "../../../../components/comman/CommonTable";
import ConfirmModal from "../../../../components/comman/ConfirmModal";
import { toast } from "react-toastify";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import { RoutesLink } from "../../../../ApiHelper/RoutesLink";
import { MainFilterHandler } from "../../../../components/comman/MainFilterHandler";

export default function OfficeLocation() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    CustomerData: [],
    filterData: "",
    type: "office"
  });

  useEffect(() => {
    GetOfficeList();
  }, [pageStates.currentPage, pageStates.pageSize]);

  const GetOfficeList = (pageNumber, filteredData) => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site + "?" + MainFilterHandler(pageStates);
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.site?.map((item) => ({
          ...item,
          toggleStatus: item?.status,
          companyName: item?.Company?.name
        }))
        setPageStates((prevStates) => ({
          ...prevStates,
          CustomerData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
      // GetOfficeList(PageNo, pageStates?.filterData);
    }
  };
  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const handleStatusToggle = (data, status) => {
    let formData = new FormData();
    formData.append("status", status ? 0 : 1);

    const options = {
      method: "POST",
      form_data: formData,
    };
    let API =
      apiUrl?.update_site + `?siteId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetOfficeList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  }

  const ActionHandler = (data) => {
    setSelectedId(data?.id)
    toggle();
  }

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_office, { state: { data: data } })
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.Delete_site + `?siteId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetOfficeList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Office" },
    { value: "companyName", label: "Company" },
    { value: "address", label: "Location" },
    { value: "range", label: "Range" },
    { value: "toggleStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
    // {
    //   label: "Delete",
    //   className: "btn btn-link",
    //   icon: <DeleteIcon />,
    //   title: "delete",
    //   clickHandler: ActionHandler,
    // },
  ];


  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Offices"}
            buttonText={"Add Office"}
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink?.add_office}
          />
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent />
              <CommonTable
                TableHeading={TableHeading}
                TableData={pageStates?.CustomerData}
                ActionData={ActionData}
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleStatusToggle={handleStatusToggle}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates.pageSize}
              />
            </div>
          </div>
        </div>
      </>
      <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  )
}
